export * from './FolderPlusIcon';
export * from './FolderPlusIcon16Light';
export * from './FolderPlusIcon16Regular';
export * from './FolderPlusIcon16Solid';
export * from './FolderPlusIcon20Light';
export * from './FolderPlusIcon20Regular';
export * from './FolderPlusIcon20Solid';
export * from './FolderPlusIcon24Regular';
export * from './FolderPlusIcon24Solid';
export * from './FolderPlusIcon32Regular';
export * from './FolderPlusIcon64Regular';
